import { takeLatest } from 'redux-saga/effects';

// Drop-in replacement for takeLatest that catches any error thrown by the
// worker. Without this, an uncaught error (e.g. an unguarded Firestore
// rejection) crashes the watcher's own task and, because takeLatest attaches
// to its parent's error boundary, cancels every sibling effect combined with
// it via all([...]) as well.
export function safeTakeLatest(pattern, worker) {
  return takeLatest(pattern, function* safeWorker(...args) {
    try {
      yield* worker(...args);
    } catch (error) {
      console.error(`Uncaught saga error handling "${pattern}":`, error);
    }
  });
}
